/**
 * core/dispose.js
 * Tiện ích dọn dẹp và giải phóng tài nguyên Three.js (Geometries, Materials, Textures)
 */

/**
 * Giải phóng an toàn một Material và các textures bên trong nó
 * @param {import('three').Material} material
 * @param {boolean} [disposeTextures=true]
 */
export function disposeMaterial(material, disposeTextures = true) {
  if (!material) return;

  if (disposeTextures) {
    const textureKeys = [
      'map',
      'alphaMap',
      'normalMap',
      'roughnessMap',
      'metalnessMap',
      'emissiveMap',
      'bumpMap',
      'specularMap',
      'envMap',
      'lightMap',
      'aoMap'
    ];

    for (const key of textureKeys) {
      if (material[key] && typeof material[key].dispose === 'function') {
        material[key].dispose();
      }
    }
  }

  if (typeof material.dispose === 'function') {
    material.dispose();
  }
}

/**
 * Duyệt đệ quy một Object3D và giải phóng toàn bộ Geometry, Material, Textures
 * @param {import('three').Object3D} root
 * @param {object} [options]
 * @param {boolean} [options.disposeTextures=true]
 * @param {boolean} [options.removeFromParent=false]
 */
export function disposeObject3D(root, options = {}) {
  const { disposeTextures = true, removeFromParent = false } = options;
  if (!root) return;

  root.traverse((child) => {
    if (child.geometry && typeof child.geometry.dispose === 'function') {
      child.geometry.dispose();
    }

    if (child.material) {
      if (Array.isArray(child.material)) {
        for (const mat of child.material) {
          disposeMaterial(mat, disposeTextures);
        }
      } else {
        disposeMaterial(child.material, disposeTextures);
      }
    }
  });

  if (removeFromParent && root.parent) {
    root.parent.remove(root);
  }
}
